import { UpdateDepartmentRequestSchema, UpdateDepartmentResponseSchema } from './update-department.schema';
/**
 * Update Department Endpoint Contract
 * Updates an existing department by ID
 */ export const updateDepartmentContract = {
    method: 'PATCH',
    path: '/api/v2/department/:id',
    description: 'Update an existing department by ID',
    requestSchema: UpdateDepartmentRequestSchema,
    responseSchema: UpdateDepartmentResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'Department not found'
        }
    }
};

//# sourceMappingURL=update-department.contract.js.map